import React from 'react';

export default function SalesOrdersTable() {
	return (
		<div id="SalesOrders" className="tab-pane active" >
			<div className="table-view table-responsive">
				<table id="sales-quotes-charge-table" className="table">
					<thead>
						<tr>
							<th>Order No.</th>
							<th>Order Date</th>
							<th>Required Date</th>
							<th>Warehouse Name</th>
							<th>Order Status</th>
							<th>Customer Code</th>
							<th>Can Ship</th>
							<th>On Shipments</th>
							<th>Shipped</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody></tbody>
				</table>
			</div>
		</div>
	);
}
